// Constants.
// -----------------------------------------------------------------------------
export const DEFAULT_MODE = 'light';
export const DEFAULT_SELECTED_COLOR = '#00ccaa';
export const INITAL_CONTEXT_VALUE = {
    selectedTabId: 0,
    setSelectedTabId: () => { }
};
//# sourceMappingURL=Tabs.constants.js.map